export const URL_MONTHS_DATA = process.env.REACT_APP_months_dataBaseURL;
export const URL_USERS_DATA = process.env.REACT_APP_users_dataBaseURL;
